import React from "react";
import clientConfig from "../../client-config";
import PortableText from "./portableText";
import * as styles from './contentBlocks.module.css';

function ContentBlocks(props) {

    let bgColor = (props.bgcolor) ? props.bgcolor.hex : '#FFFFFF';

    if(props.blocks){

        return (
            <div className={styles.sectionContentBlocks} style={{ backgroundColor: `${bgColor}`}}>
                <div className={styles.sectionContainer}>
                    <h2>{props.heading}</h2>
                    <div className={styles.intro}>
                        <PortableText blocks={props.intro} />
                    </div>
                    <div className={styles.blocksWrapper}>
                        {
                            props.blocks.map((item, i) => {  
                                return (
                                    <div className={styles.blockItem}>
                                        <h3>{item.subheading}</h3>
                                        <PortableText blocks={item.content} />
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </div>
        );

    } else {

        return (
            <div className={styles.sectionContentBlocks} style={{ backgroundColor: `${bgColor}`}}>
                <div className={styles.sectionContainer}>
                    <h2>{props.heading}</h2>
                    <div className={styles.intro}>
                        <PortableText blocks={props.intro} />
                    </div>
                    <div className={styles.blocksWrapper}>
                    </div>
                </div>
            </div>
        );

    }
}

export default ContentBlocks;